export default "__VITE_ASSET__DSRfiXaf__"